// @ts-nocheck
import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import parseQueryString from "@insite/client-framework/Common/Utilities/parseQueryString";
import {
    addSearchHistory,
    getSearchHistory,
    SearchHistoryItem,
} from "@insite/client-framework/Services/AutocompleteService";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import getAutocompleteModel from "@insite/client-framework/Store/CommonHandlers/GetAutocompleteModel";
import sendSearchTracking from "@insite/client-framework/Store/CommonHandlers/SendSearchTracking";
import { getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import { getLocation } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import translate from "@insite/client-framework/Translate";
import { AutocompleteItemModel, AutocompleteModel } from "@insite/client-framework/Types/ApiModels";
import AutocompleteBrands, {
    AutocompleteBrandsStyles,
} from "@insite/content-library/Widgets/Header/AutocompleteBrands";
import AutocompleteCategories, {
    AutocompleteCategoriesStyles,
} from "@insite/content-library/Widgets/Header/AutocompleteCategories";
import AutocompleteContent, {
    AutocompleteContentStyles,
} from "@insite/content-library/Widgets/Header/AutocompleteContent";
import AutocompleteProducts, {
    AutocompleteProductsStyles,
} from "@insite/content-library/Widgets/Header/AutocompleteProducts";
import SearchHistory, { SearchHistoryStyles } from "@insite/content-library/Widgets/Header/SearchHistory";
import { FormFieldSizeVariant } from "@insite/mobius/FormField";
import { sizeVariantValues } from "@insite/mobius/FormField/formStyles";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
// import Search from "@insite/mobius/Icons/Search"; // Starter Custom Code
import Popover, {
    ContentBodyProps,
    OverflowWrapperProps,
    PopoverPresentationProps,
    PositionStyle,
} from "@insite/mobius/Popover";
import TextField, { TextFieldPresentationProps } from "@insite/mobius/TextField";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import { HasHistory, withHistory } from "@insite/mobius/utilities/HistoryContext";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import VisuallyHidden from "@insite/mobius/VisuallyHidden";
import debounce from "lodash/debounce";
import throttle from "lodash/throttle";
import React from "react";
import { connect, ResolveThunks } from "react-redux";
import { css, ThemeProps, withTheme } from "styled-components";

/* Starter Custom Code - Start */
import getColor from "@insite/mobius/utilities/getColor";
import Search from "@store/Library/Components/Toolkit/Icons/Search";
import { autocompleteFontStyles } from "@store/Themes/common/mixins/autocomplete";
import { buttonGetFieldIconProps } from "@store/Themes/common/props/button";
import breakpoint from "@toolkit/Framework/Common/Utilities/breakpoint";
import mergeProps from "@toolkit/Framework/Common/Utilities/mergeProps";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";

const getColumnProps = (width: string): InjectableCss => ({
    css: css`
        flex: 1 1 auto;
        width: ${pxToRem(width)};
        max-width: 100%;
    `,
});
/* Starter Custom Code - End */

// Foundation --->
import ClockLine from "@store/Library/Components/Icons/Clock/ClockLine";
import { contentSpacingStyles } from "@store/Themes/common/mixins/spacing";
import { ButtonIcon } from "@insite/mobius/Button";
import Hidden from "@insite/mobius/Hidden";
import { IconProps, IconWrapper } from "@insite/mobius/Icon";
import { StyledTypography } from "@insite/mobius/Link";
import Modal, { ModalPresentationProps } from "@insite/mobius/Modal";
import breakpointValues from "@toolkit/Framework/Common/Utilities/breakpointValues";
// <--- Foundation

interface OwnProps {
    /** A unique identifier to assist with id-generation for `aria-controls`. */
    readonly id: string;
    inputRef?: React.Ref<HTMLInputElement>;
    autocompletePositionFunction?: (element: React.RefObject<HTMLUListElement>) => PositionStyle;
    onBeforeGoToUrl?: () => void;
    extendedStyles?: SearchInputStyles;
    isAnimated?: boolean;
}

const mapStateToProps = (state: ApplicationState) => {
    const {
        searchSettings: { autocompleteEnabled, searchHistoryEnabled, searchHistoryLimit, searchPath },
    } = getSettingsCollection(state);
    return {
        autocompleteEnabled,
        searchHistoryEnabled,
        searchHistoryLimit,
        location: getLocation(state),
        searchPath,
    };
};

const mapDispatchToProps = {
    getAutocompleteModel,
    sendSearchTracking,
};

type Props = OwnProps &
    ThemeProps<BaseTheme> &
    HasHistory &
    ReturnType<typeof mapStateToProps> &
    ResolveThunks<typeof mapDispatchToProps>;

interface State {
    query: string;
    focusableAutocompleteItems: AutocompleteItemModel[];
    focusedAutocompleteItem?: AutocompleteItemModel;
    focusedSearchHistoryQuery?: string;
    autoCompleteModel?: AutocompleteModel;
    isLoading: boolean;
    mobileSearchModalIsOpen: boolean; // Foundation
}

const DOWN_KEY = 40;
const UP_KEY = 38;
const ENTER_KEY = 13;

export interface SearchInputStyles {
    input?: TextFieldPresentationProps;
    popover?: PopoverPresentationProps;
    popoverWrapper?: OverflowWrapperProps;
    popoverContentBody?: ContentBodyProps;
    autocompleteWrapper?: InjectableCss;
    autocompleteColumnWrapper?: InjectableCss;
    searchHistoryStyles?: SearchHistoryStyles;
    autocompleteCategoriesStyles?: AutocompleteCategoriesStyles;
    autocompleteBrandsStyles?: AutocompleteBrandsStyles;
    autocompleteContentStyles?: AutocompleteContentStyles;
    autocompleteProductsStyles?: AutocompleteProductsStyles;
    // Starter Custom Code
    popoverContentWrapper?: InjectableCss;
    autocompleteColumnProductWrapper?: InjectableCss;
    // Foundation
    mobileSearchIcon?: IconProps;
    mobileSearchIconWrapper?: InjectableCss;
    mobileSearchModal?: ModalPresentationProps;
    mobileSearchModalCloseIcon?: IconProps;
}

// Foundation --->
const searchInputGenericHeader = {
    color: "primary",
    css: css`
        font-size: ${({ theme }) => theme.design.typography.size.large};
        font-weight: ${({ theme }) => theme.design.typography.weight.bold};
    `,
};

const linkAccentStateStyle = {
    color: "primary",
    css: css`
        width: 100%;
        background-color: ${getColor("common.accent")};
    `,
};
// <--- Foundation

export const searchInputStyles: SearchInputStyles = {
    // Store Custom Code
    input: {
        sizeVariant: "default",
        iconProps: {
            src: Search,
            size: 24,
            css: css`
                color: ${getColor("primary")};
            `,
        },
        border: "rectangle",
        cssOverrides: {
            formInputWrapper: css`
                ${IconWrapper} {
                    > * {
                        width: ${pxToRem(24)};
                        height: ${pxToRem(24)};
                    }
                }
            `,
            formField: css`
                width: 100%;
            `,
            inputSelect: css<any>`
                padding-right: 3em;
                ${breakpointValues([null, null, "3em"], "padding-right")}

                &:active, &:focus {
                    border: ${pxToRem(2)} solid ${getColor("primary")};
                    ${breakpointValues([null, null, "3em"], "padding-right")}
                }
            `,
        },
    },
    popover: {
        transitionDuration: "short",
        toggle: false,
    },
    popoverWrapper: {
        as: "div",
        _height: "auto",
        css: css`
            display: inline-flex;
            justify-content: flex-end;
        `,
    },
    popoverContentBody: {
        as: "div",
        _height: "70vh",
        css: css`
            box-shadow: ${({ theme }) => theme.shadows.main};

            > * {
                width: 100%;
            }
        `,
    },
    autocompleteWrapper: {
        css: css`
            display: flex;
            flex-direction: column;
            flex-wrap: wrap;
            width: 100%;
            padding: ${pxToRem(20)};
            overflow-x: hidden;
        `,
    },
    autocompleteColumnWrapper: {
        css: css`
            display: flex;
            flex-direction: column;
            flex-wrap: wrap;
            width: 100%;
            ${contentSpacingStyles(0, 0, pxToRem(20))}
        `,
    },
    // Foundation
    searchHistoryStyles: {
        headerText: {
            color: "primary",
            css: css`
                display: flex;
                margin-bottom: ${pxToRem(5)};
                font-size: ${({ theme }) => theme.design.typography.size.large};
            `,
        },
        wrapper: {
            css: css`
                padding: ${pxToRem(20)};
                overflow-x: hidden;
            `,
        },
        itemWrapper: {
            css: css`
                display: flex;
                align-items: center;
                ${contentSpacingStyles(0, 0, pxToRem(5))}

                &:hover, :focus {
                    ${linkAccentStateStyle.css}
                }
            `,
        },
        icon: {
            src: ClockLine,
            color: "primary",
            size: 18,
            css: css`
                margin-right: ${pxToRem(10)};
            `,
        },
        link: {
            color: "primary",
            css: css`
                width: 90%;

                &:hover {
                    ${linkAccentStateStyle.css}
                }
            `,
            typographyProps: {
                ellipsis: true,
            },
        },
        focusedLink: linkAccentStateStyle,
        clearLink: {
            color: "text.main",
            css: css`
                &:hover {
                    > ${StyledTypography} {
                        color: ${getColor("secondary")};
                        text-decoration: underline;
                    }
                }
            `,
            typographyProps: {
                css: css`
                    font-size: ${({ theme }) => theme.design.typography.size.smaller};
                    font-weight: ${({ theme }) => theme.design.typography.weight.base};
                `,
            },
        },
    },
    autocompleteCategoriesStyles: {
        headerText: searchInputGenericHeader,
        link: {
            color: "primary",
            css: css`
                &:hover {
                    ${linkAccentStateStyle.css}
                }
            `,
        },
        focusedLink: linkAccentStateStyle,
        categoryItemText: {
            color: "text.main",
            css: css`
                width: 100%;

                &:hover {
                    ${linkAccentStateStyle.css}
                }
            `,
        },
        focusedCategoryItemText: linkAccentStateStyle,
    },
    autocompleteBrandsStyles: {
        headerText: searchInputGenericHeader,
        link: {
            color: "primary",
            css: css`
                width: 100%;

                &:hover {
                    ${linkAccentStateStyle.css}
                }
            `,
        },
        focusedLink: linkAccentStateStyle,
        focusedBrandItemText: linkAccentStateStyle,
    },
    autocompleteContentStyles: {
        headerText: searchInputGenericHeader,
        link: {
            color: "primary",
            css: css`
                width: 100%;

                &:hover {
                    ${linkAccentStateStyle.css}
                }
            `,
        },
        focusedLink: linkAccentStateStyle,
    },
    autocompleteProductsStyles: {
        headerText: searchInputGenericHeader,
        container: {
            css: css`
                margin: ${pxToRem(5)} 0;

                &:hover {
                    ${linkAccentStateStyle.css}
                }
            `,
        },
        focusedContainer: {
            css: css`
                margin: ${pxToRem(5)} 0;
                ${linkAccentStateStyle.css}
            `,
        },
        titleLink: {
            color: "primary",
            css: css`
                width: 100%;
                font-weight: ${({ theme }) => theme.design.typography.weight.medium};
            `,
        },
        erpNumberText: {
            color: "text.main",
            css: css`
                margin: 0;
                font-size: ${({ theme }) => theme.design.typography.size.smaller};
            `,
        },
    },
    mobileSearchIconWrapper: {
        css: css`
            display: flex;
        `,
    },
    mobileSearchIcon: {
        color: "primary",
        size: 28,
        css: css`
            margin-right: 0.5em;
            margin-left: auto;
        `,
    },
    mobileSearchModal: {
        cssOverrides: {
            modalContent: css`
                width: 100%;
                padding: ${pxToRem(20)} ${pxToRem(30)};

                > * {
                    padding: 0;
                }
            `,
        },
        closeButtonProps: {
            css: css`
                &:hover {
                    background-color: ${getColor("common.background")};
                    border-color: ${getColor("common.background")};

                    > ${IconWrapper} {
                        color: ${getColor("secondary")};
                    }
                }
            `,
        },
    },
};

const styles = searchInputStyles;

class SearchInput extends React.Component<Props, State> {
    private readonly styles: SearchInputStyles;

    constructor(props: Props) {
        super(props);

        this.styles = mergeProps<typeof styles>(styles, props.extendedStyles); // Starter Custom Code
        const parsedQuery = parseQueryString<{ query?: string }>(this.props.location.search);

        this.state = {
            query: parsedQuery.query || "",
            focusableAutocompleteItems: [],
            isLoading: false,
            mobileSearchModalIsOpen: false, // Foundation
        };
    }

    list = React.createRef<HTMLUListElement>();
    popover = React.createRef<any>();
    showAutocomplete = true;

    componentDidUpdate(prevProps: Props, prevState: State) {
        if (this.props.location.pathname !== prevProps.location.pathname) {
            // clear the search box on navigate away from search
            if (!this.props.location.pathname.toLowerCase().startsWith(`/${this.props.searchPath.toLowerCase()}`)) {
                // TODO ISC-12679 - Redesign so that this can be moved to a field of the class rather than state.
                // eslint-disable-next-line react/no-did-update-set-state
                this.setState({ query: "" });
            } else {
                this.closeAutocomplete();
            }
        }
        /* Starter Removed - && prevState.autoCompleteModel */
        if (this.state.autoCompleteModel && this.state.autoCompleteModel !== prevState.autoCompleteModel) {
            this.updateFocusableItems();
        }
    }

    componentDidMount() {
        window.addEventListener("resize", this.handleResize, true);
    }

    componentWillUnmount() {
        window.removeEventListener("resize", this.handleResize);
    }

    handleResize = () => {
        this.updateFocusableItems();
    };

    updateFocusableItems = () => {
        if (this.state.isLoading || !this.state.autoCompleteModel) {
            return;
        }

        const { categories, brands, content, products } = this.state.autoCompleteModel;
        /* Starter Removed - isProductsOnTop */
        const newFocusableOptions = (products || ([] as AutocompleteItemModel[]))
            .concat(categories || [])
            .concat(brands || [])
            .concat(content || []);
        this.setState({
            focusableAutocompleteItems: newFocusableOptions,
            focusedAutocompleteItem: undefined,
            focusedSearchHistoryQuery: undefined,
        });
    };

    doSearch = () => {
        if (this.state.query.trim() === "") {
            return;
        }

        this.showAutocomplete = false;
        if (this.state.autoCompleteModel?.products?.length === 1) {
            this.goToUrl(this.state.autoCompleteModel?.products[0].url);
        } else {
            const encodedQuery = encodeURIComponent(this.state.query);
            this.goToUrl(`/${this.props.searchPath}?query=${encodedQuery}`, false);

            if (this.props.location.pathname.toLowerCase().startsWith(`/${this.props.searchPath.toLowerCase()}`)) {
                // if we already on the Search page then scroll to top
                window.scrollTo(0, 0);
            }
        }
        if (this.props.searchHistoryEnabled) {
            addSearchHistory(this.state.query, this.props.searchHistoryLimit);
        }
    };

    loadAutocomplete = debounce((query: string) => {
        this.props.getAutocompleteModel({
            query,
            onSuccess: result => {
                if (this.showAutocomplete) {
                    this.setState({
                        autoCompleteModel: result,
                    });
                    this.openAutocomplete();
                }
            },
            onComplete(resultProps) {
                if (resultProps.apiResult) {
                    this.onSuccess?.(resultProps.apiResult);
                }
            },
        });
    }, 200);

    handleInputChange = (event: React.ChangeEvent<HTMLInputElement>, toggleAutoComplete = true) => {
        this.showAutocomplete = toggleAutoComplete;
        const newQuery = event.target.value;
        this.setState({ query: newQuery });
        this.loadAutocomplete(newQuery);
    };

    openAutocomplete = () => {
        this.popover.current && (this.popover.current! as any).openPopover();
    };

    closeAutocomplete = () => {
        this.popover.current && (this.popover.current! as any).closePopover();
    };

    getPopoverPosition = (element: React.RefObject<HTMLUListElement>) => {
        if (this.props.autocompletePositionFunction) {
            return this.props.autocompletePositionFunction(element);
        }

        const positionStyle: PositionStyle = {
            position: "absolute", // Starter Custom Code
        };

        /* Store Custom Code - Start */
        if (element.current) {
            const rect = element.current.getBoundingClientRect();
            positionStyle.top = pxToRem(45);
            positionStyle.right = 0;
            positionStyle.left = 0;
        }
        /* Store Custom Code - End */

        return positionStyle;
    };

    moveFocus = throttle((direction: "prev" | "next") => {
        if (this.state.query) {
            this.setState(({ focusedAutocompleteItem, focusableAutocompleteItems }) => {
                const focusableQueue =
                    direction === "prev" ? focusableAutocompleteItems.slice().reverse() : focusableAutocompleteItems;
                const focusedIndex = focusableQueue.indexOf(focusedAutocompleteItem as AutocompleteItemModel);
                const newFocusedOption = focusableQueue.find((_, index) => index > focusedIndex);
                return { focusedAutocompleteItem: newFocusedOption };
            });
        } else {
            this.setState(({ focusedSearchHistoryQuery }) => {
                const searchHistoryItems = getSearchHistory();
                const focusableQueue = direction === "prev" ? searchHistoryItems.slice().reverse() : searchHistoryItems;
                const focusedSearchHistoryItem = focusableQueue.find(o => o.query === focusedSearchHistoryQuery);
                const focusedIndex = focusableQueue.indexOf(focusedSearchHistoryItem as SearchHistoryItem);
                const newFocusedOption = focusableQueue.find((_, index) => index > focusedIndex);
                return { focusedSearchHistoryQuery: newFocusedOption?.query };
            });
        }
    }, 100);

    handlePopoverKeyDown = (event: KeyboardEvent) => {
        switch (event.keyCode) {
            case DOWN_KEY:
                this.moveFocus("next");
                break;
            case UP_KEY:
                this.moveFocus("prev");
                break;
            case ENTER_KEY:
                if (this.state.focusedAutocompleteItem) {
                    this.goToUrl(this.state.focusedAutocompleteItem.url);
                } else if (this.state.focusedSearchHistoryQuery) {
                    this.setState({ query: this.state.focusedSearchHistoryQuery }, () => {
                        this.doSearch();
                    });
                } else {
                    this.doSearch();
                }
                break;
            default:
                break;
        }
    };

    handlePopoverClose = () => {
        this.setState({
            focusedAutocompleteItem: undefined,
            focusedSearchHistoryQuery: undefined,
        });
    };

    trackAutcompleteSearchResults = () => {
        // Make sure only to trigger for autocomplete results
        if (!this.state.query || !this.props.autocompleteEnabled || !this.state.autoCompleteModel) {
            return;
        }

        const { categories, brands, content, products } = this.state.autoCompleteModel;
        const resultCount =
            (products?.length ?? 0) + (categories?.length || 0) + (content?.length || 0) + (brands?.length || 0);
        if (resultCount > 0) {
            // Track an autocomplete of 1+ items
            this.props.sendSearchTracking({
                searchEvent: "autocompleteSearchResults",
                searchTerm: this.state.query,
                resultCount,
                productCount: products?.length,
                categoryCount: categories?.length,
                contentCount: content?.length,
                brandCount: brands?.length,
            });
            return;
        }

        // Track zero resultCount search results and triggers from this.doSearch
        this.props.sendSearchTracking({
            searchEvent: "searchResults",
            searchTerm: this.state.query,
            resultCount,
        });
    };

    goToUrl = (url: string, track = true) => {
        this.props.onBeforeGoToUrl && this.props.onBeforeGoToUrl();
        if (track) {
            this.trackAutcompleteSearchResults();
        }
        this.closeAutocomplete();
        this.mobileSearchModalCloseHandler(); // Foundation
        this.setState({
            // don't use stale results on next search and go to wrong PDP
            autoCompleteModel: undefined,
        });
        this.props.history.push(url);
    };

    // Foundation --->
    mobileSearchInput = React.createRef<HTMLInputElement>();

    getMobileSearchAutocompletePosition = (element: React.RefObject<HTMLUListElement>) => {
        const positionStyle: PositionStyle = {
            position: "fixed",
        };

        if (element.current) {
            const rect = element.current.getBoundingClientRect();
            positionStyle.top = rect.top + rect.height;
            positionStyle.left = 0;
            positionStyle.width = `${document.documentElement.clientWidth}px`;
            positionStyle.height = `${document.documentElement.clientHeight - positionStyle.top}px`;
        }

        return positionStyle;
    };

    mobileSearchButtonClickHandler = () => {
        this.setState({ mobileSearchModalIsOpen: true }, () => {
            setTimeout(() => {
                if (this.mobileSearchInput?.current) {
                    this.mobileSearchInput.current.focus();
                    this.mobileSearchInput.current.click();
                }
            }, 250);
        });
    };

    mobileSearchModalCloseHandler = () => {
        this.setState({ mobileSearchModalIsOpen: false });
    };
    // <--- Foundation

    renderAutocomplete = () => {
        if (!this.props.autocompleteEnabled) {
            return null;
        }

        if (!this.state.autoCompleteModel) {
            return null;
        }

        const { categories, brands, content, products } = this.state.autoCompleteModel;

        return (
            <StyledWrapper {...this.styles.autocompleteWrapper} className="autocomplete-wrapper">
                {/* Foundation MovedCode to bottom - Condition */}
                {products && products.length > 0 && (
                    <StyledWrapper {...this.styles.autocompleteColumnWrapper} className="autocomplete-column-wrapper">
                        <AutocompleteProducts
                            products={products}
                            focusedItem={this.state.focusedAutocompleteItem}
                            goToUrl={this.goToUrl}
                            extendedStyles={this.styles.autocompleteProductsStyles}
                        />
                    </StyledWrapper>
                )}
                {/* Foundation ---> */}
                {categories && categories.length > 0 && (
                    <StyledWrapper {...this.styles.autocompleteColumnWrapper} className="autocomplete-column-wrapper">
                        <AutocompleteCategories
                            categories={categories}
                            focusedItem={this.state.focusedAutocompleteItem}
                            goToUrl={this.goToUrl}
                            extendedStyles={this.styles.autocompleteCategoriesStyles}
                        />
                    </StyledWrapper>
                )}
                {brands && brands.length > 0 && (
                    <StyledWrapper {...this.styles.autocompleteColumnWrapper}>
                        <AutocompleteBrands
                            brands={brands}
                            focusedItem={this.state.focusedAutocompleteItem}
                            goToUrl={this.goToUrl}
                            extendedStyles={this.styles.autocompleteBrandsStyles}
                        />
                    </StyledWrapper>
                )}
                {content && content.length > 0 && (
                    <StyledWrapper {...this.styles.autocompleteColumnWrapper}>
                        <AutocompleteContent
                            content={content}
                            focusedItem={this.state.focusedAutocompleteItem}
                            goToUrl={this.goToUrl}
                            extendedStyles={this.styles.autocompleteContentStyles}
                        />
                    </StyledWrapper>
                )}
                {/* <--- Foundation */}
            </StyledWrapper>
        );
    };

    /* Starter Custom Code - Start */
    hasSearchResults() {
        const { categories, brands, content, products } = this.state.autoCompleteModel || {};
        return Boolean(categories?.length || brands?.length || content?.length || products?.length);
    }
    /* Starter Custom Code - End */

    render() {
        const styles = this.styles;
        const searchId = `headerSearch-${this.props.id}`;

        const searchInput = (
            <TextField
                {...styles.input}
                ref={this.props.inputRef}
                isAnimated={this.props.isAnimated}
                iconClickableProps={{ onClick: this.doSearch, ...styles.input?.iconClickableProps }} // Starter Custom Code
                value={this.state.query}
                onChange={this.handleInputChange}
                placeholder={translate("Search")}
                autoComplete="off"
                clickableText={translate("submit search")}
                id={searchId}
                data-test-selector="headerSearchInputTextField"
                className="search-input"
                type="search" // Starter Custom Code
            />
        );

        /* Starter Custom Code - Start */
        const showSearchHistory = !this.state.query && this.showAutocomplete && getSearchHistory().length;
        const showSearchResults = this.state.query && this.props.autocompleteEnabled && this.hasSearchResults();
        const sizeVariant = sizeVariantValues[this.styles?.input?.sizeVariant || ("default" as FormFieldSizeVariant)];

        const popoverContentBodyStyles = mergeProps<ContentBodyProps>(styles.popoverContentBody, {
            css: css`
                border-bottom-right-radius: ${sizeVariant.borderRadius}px;
                border-bottom-left-radius: ${sizeVariant.borderRadius}px;
            `,
        });
        /* Starter Custom Code - End */

        return (
            <>
                <VisuallyHidden as="label" htmlFor={searchId} id={`${searchId}-label`}>
                    {translate("Site Search")}
                </VisuallyHidden>
                {/* Foundation - Hidden */}
                <Hidden below="sm">
                    <Popover
                        {...styles.popover}
                        controlsId={`${searchId}-popover`}
                        ref={this.popover}
                        insideRefs={[this.list]}
                        popoverTrigger={searchInput}
                        positionFunction={this.getPopoverPosition}
                        wrapperProps={styles.popoverWrapper}
                        contentBodyProps={
                            {
                                ref: this.list,
                                ...popoverContentBodyStyles, // Starter Custom Code
                            } as any
                        }
                        handleKeyDown={this.handlePopoverKeyDown}
                        onClose={this.handlePopoverClose}
                        className="popover"
                    >
                        {/* Starter Custom Code - Start */}
                        {showSearchHistory || showSearchResults ? (
                            <StyledWrapper {...styles.popoverContentWrapper}>
                                <StyledWrapper {...this.styles.autocompleteWrapper}>
                                    {!this.state.query && this.showAutocomplete && (
                                        <StyledWrapper {...this.styles.autocompleteColumnWrapper}>
                                            <SearchHistory
                                                focusedQuery={this.state.focusedSearchHistoryQuery}
                                                goToUrl={this.goToUrl}
                                                extendedStyles={styles.searchHistoryStyles}
                                            />
                                        </StyledWrapper>
                                    )}
                                    {this.state.query && this.renderAutocomplete()}
                                </StyledWrapper>
                            </StyledWrapper>
                        ) : null}
                        {/* Starter Custom Code - End */}
                    </Popover>
                </Hidden>
                {/* Foundation - Hidden */}
                {/* Foundation */}
                <Hidden above="xs" {...styles.mobileSearchIconWrapper}>
                    <ButtonIcon
                        {...styles.mobileSearchIcon}
                        src={Search}
                        onClick={this.mobileSearchButtonClickHandler}
                    />
                </Hidden>
                <Modal
                    {...styles.mobileSearchModal}
                    isOpen={this.state.mobileSearchModalIsOpen}
                    closeOnEsc={true}
                    handleClose={this.mobileSearchModalCloseHandler}
                    headline={searchInput}
                >
                    {!this.state.query && this.showAutocomplete && (
                        <SearchHistory
                            focusedQuery={this.state.focusedSearchHistoryQuery}
                            goToUrl={this.goToUrl}
                            extendedStyles={styles.searchHistoryStyles}
                        />
                    )}
                    {this.state.query && this.renderAutocomplete()}
                </Modal>
                {/* Foundation */}
            </>
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(withHistory(withTheme(SearchInput)));
